export default __webpack_public_path__ + "0f6806df2d79941e6a5322bf1214f70b.svg";